<template>
<div>
    <div class="form-row">
        <div class="col">
            <form-input :model-value="allPositions" @update:model-value="$emit('update:allPositions', $event)" :errors="errors.all_positions" type="checkbox" label="Available to all companies in this client" />
        </div>
    </div>

    <template v-if="!allPositions">
        <form-errors :errors="errors.positions"/>
        <position-selector v-if="positionsLoaded" :all-positions="clientPositions" :companies="client.companies" :model-value="positions" @update:model-value="$emit('update:positions', $event)"/>
    </template>
</div>
</template>

<script>
import PositionSelector from '@/pages/client/Settings/components/PositionSelector'

export default {
    props: ['client', 'allPositions', 'positions', 'errors', ],
    emits: ['update:allPositions', 'update:positions', ],
    components: {PositionSelector, },
    data() {
        return {
            clientPositions: [],
            positionsLoaded: false,
        }
    },
    mounted() {
        this.$api.get(`/clients/${this.client.id}/positions`).then(resp => {
            this.clientPositions = resp.sort((a, b) => a.terminal_value.toLowerCase() > b.terminal_value.toLowerCase() ? 1 : -1)
            this.positionsLoaded = true
        }).catch((errors) => {
            this.$bus.showError(errors.__all__)
        })
    },
}
</script>
